import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import AutoForm from 'react-auto-form';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

//import { ToastContainer, toast } from "react-toastify";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
    interviewPersonCategories,
    //returnTypeIdNameArrayElement
} from '../components/Enums';

export class E_Mq extends Component {
    constructor(props) {
        super(props);
        this.state = {
            missionId: props.propMissionId,
            lastOnChange: null,
            lastOnSubmit: null,
            trim: false,
            trimOnSubmit: false,
            pageLoadData: {},
            templateId: props.propTemplateId,
            countOtherDocuments: 1,
            countPerson: 1,
            //interviewPersonCategories: [
            //    { TypeId: 1, TypeName: "Beneficiary" },
            //    { TypeId: 2, TypeName: "Partner Country" },
            //    { TypeId: 3, TypeName: "Stakeholder" },
            //    { TypeId: 4, TypeName: "Other" },
            //    { TypeId: 5, TypeName: "NIPAC" },
            //    { TypeId: 6, TypeName: "EU Delegation" },
            //    { TypeId: 7, TypeName: "Contracting Authority" },
            //    { TypeId: 8, TypeName: "End Beneficiary" },
            //    { TypeId: 9, TypeName: "Lead Institution" },
            //],
        };
    }

    _onChange = (e, name, data, change) => {
        //console.log(name, data, change);
        //console.log(data);
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[name] = data;

        this.setState({
            lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        //console.log(this.state);
    }

    _onSubmit = (e, data) => {
        //console.log("submit")
        //console.log(data)
        //this.setState({ lastOnSubmit: { data } })
        //e.preventDefault()

        console.log("submit");
        //console.log(data);
        this.setState({ lastOnSubmit: { data } });

        let dataToSubmit = data;
        dataToSubmit["missionId"] = this.state.missionId;
        dataToSubmit["templateId"] = this.state.templateId;
        dataToSubmit["countOtherDocuments"] = this.state.countOtherDocuments;
        dataToSubmit["countPerson"] = this.state.countPerson;
        console.log(dataToSubmit);

        this.props.propUpdatePageLoadData(dataToSubmit);

        fetch(global.variables.API_TEMPLATEFILLER_FILLANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(dataToSubmit)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.resultstate === 0) {
                    toast.success("Success!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                } else {
                    toast.error("Failed!", {
                        position: toast.POSITION.BOTTOM_RIGHT
                    });
                }
            });

        e.preventDefault();
    }

    _onOptionsChange = (e, name, data, change) => {
        console.log(data);
        this.setState(change);
    };

    async componentDidMount() {
        await fetch(global.variables.API_TEMPLATEFILLER_GETANSWERS, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                operation: "GetExpostMq",
                missionId: this.state.missionId,
                templateId: this.state.templateId
            })
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                if (result.saveddata.length > 0) {
                    this.setState({
                        pageLoadData: JSON.parse(result.saveddata[0].TemplateAnswers),
                    });

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments > 0) {
                        this.setState({
                            countOtherDocuments: JSON.parse(result.saveddata[0].TemplateAnswers).countOtherDocuments,
                        });
                    } else {
                        this.setState({
                            countOtherDocuments: 1,
                        });
                    }

                    if (JSON.parse(result.saveddata[0].TemplateAnswers).countPerson !== undefined &&
                        JSON.parse(result.saveddata[0].TemplateAnswers).countPerson > 0) {
                        this.setState({
                            countPerson: JSON.parse(result.saveddata[0].TemplateAnswers).countPerson,
                        });
                    } else {
                        this.setState({
                            countPerson: 1,
                        });
                    }
                }
            });

        this.props.propUpdatePageLoadData(this.state.pageLoadData);

        //console.log(this.state.pageLoadData);
        //console.log(this.state.pageLoadData.OmrQ1Context);
        //this.forceUpdate();
    }

    checkIfChecked = (element, value) => {
        if (element === value) {
            return true;
        } else {
            return false;
        }
    };

    incrementOtherDocuments = () => {
        var countOtherDocuments = this.state.countOtherDocuments;

        if (countOtherDocuments < 20) {
            countOtherDocuments += 1;
        }

        this.setState({ countOtherDocuments: countOtherDocuments });
    }

    incrementPerson = () => {
        var countPerson = this.state.countPerson;

        if (countPerson < 20) {
            countPerson += 1;
        }

        this.setState({ countPerson: countPerson });
    }

    handleSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeUseValue = async (e, v, vname) => {
        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        pageLoadDataChange[vname] = v.TypeName;
        //if (v !== undefined & v !== null) {
        //    pageLoadDataChange[vname] = v.TypeId;
        //} else {
        //    pageLoadDataChange[vname] = -1;
        //}

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        //if (v !== undefined & v !== null) {
        //    await this.setState({ [vname]: v.TypeName });
        //} else {
        //    await this.setState({ [vname]: "" });
        //}

        console.log(this.state);
    }

    handleSelectChangePageLoadData = async (e, v, vname) => {

        //console.log("handleSelectChangePageLoadData vId: " + v.TypeId + " vName: " + v.TypeName + " vname: " + vname);

        e.persist();

        //console.log(data)
        //this.setState({ lastOnChange: { name, data, change } })

        var pageLoadDataChange = this.state.pageLoadData;
        //pageLoadDataChange[vname] = v.TypeName;
        if (v !== undefined & v !== null) {
            //pageLoadDataChange[vname] = v.TypeId;
            pageLoadDataChange[vname] = v.TypeName;
        } else {
            pageLoadDataChange[vname] = -1;
        }

        this.setState({
            //lastOnChange: { name, data, change },
            pageLoadData: pageLoadDataChange
        });

        console.log(this.state);
    }

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    returnArrayElementUseValue = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeName === element) {
                return array[i];
            }
        }

        return ({ TypeId: "", TypeName: "" });
    };

    render() {
        //let {lastOnChange, lastOnSubmit, trim, trimOnSubmit} = this.state
        //let { trim, trimOnSubmit } = this.state
        let {
            trim,
            trimOnSubmit,
            pageLoadData,
            countOtherDocuments,
            countPerson,
            //interviewPersonCategories,
        } = this.state;

        return (
            <Grid container>
                <AutoForm onSubmit={this._onSubmit} onChange={this._onChange} trim={!!trim} trimOnSubmit={!!trimOnSubmit} style={{ width: "100%" }}>
                    <Grid item xs={12}>

                        <br />
                        <p>1. Relevance</p>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.1 Did the project constitute an adequate response to the prevailing needs and rights of the target groups / end beneficiaries?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>

                                <RadioGroup aria-label="gender" name="EmqQ1Didthe" >
                                    <Grid item xs direction="column">
                                        {
                                            //<FormControlLabel value="green" control={<Radio />} className="green" />
                                            //<FormControlLabel value="yellow" control={<Radio />} className="yellow" />
                                            //<FormControlLabel value="red" control={<Radio />} className="red" />
                                        }
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ1Didthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ1Didthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ1Didthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        rows={2}
                                        style={{ width: "100%" }}
                                        name="EmqQ2Didthe"
                                        defaultValue={this.state.pageLoadData.EmqQ2Didthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.2 Was the project adapted to the then institutional, human and financial capacities of the partner government and/or other key stakeholder(s) with a role in the implementation?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ3Hasthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ3Hasthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ3Hasthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ3Hasthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ4Hasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ4Hasthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.3 Did all the key stakeholders demonstrate effective commitment (i.e. ownership) to the objectives of the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ5Havethe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ5Havethe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ5Havethe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ5Havethe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ6Havethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ6Havethe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.4 Was there an effective government-led system of sector coordination (including Capacity Development) involving the relevant local stakeholders and donors?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>

                                <RadioGroup aria-label="gender" name="EmqQ7Hasthere" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ7Hasthere, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ7Hasthere, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ7Hasthere, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>


                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ8Hasthere"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ8Hasthere}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.5 Did the project benefit from any complementarity/synergies with other projects funded by the EU or other donors (public or private)?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ9Havethere" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ9Havethere, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ9Havethere, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ9Havethere, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ10Havethere"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ10Havethere}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.6 What was the quality of the intervention logic? Were planned outputs and outcomes coherent and feasible, and were key assumptions and risks clearly identified?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ11Hasan" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ11Hasan, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ11Hasan, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ11Hasan, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ12Hasan"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ12Hasan}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7a Were the indicators well defined and relevant to measure the achievement of the objectives?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ13Werethe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ13Werethe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ13Werethe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ13Werethe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ14Werethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ14Werethe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7b Was the horizontal logic of the Logical Framework Matrix (LFM) adequate, i.e. choice of indicators, data availability, baseline data, target values? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ15Hasall" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ15Hasall, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ15Hasall, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ15Hasall, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ16Hasall"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ16Hasall}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7c Were the indicators sex-disaggregated (if relevant)?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ17Havethe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ17Havethe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ17Havethe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ17Havethe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ18Havethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ18Havethe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7d Were baselines set for each indicator? Were they updated during the project implementation?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ19Were" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ19Were, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ19Were, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ19Were, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ20Were"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ20Were}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >1.7e Were target values set at the start of the project? If so, were they realistic or was there a need to revise/update them in the course of the project? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ21Were" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ21Were, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ21Were, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ21Were, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ22Were"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ22Were}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 1 (Relevance)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqConclusion1Relevance"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqConclusion1Relevance}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>2. Efficiency</p>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.1 Were the chosen implementation mechanisms (including choice of implementation modalities, entities and contractual arrangements) proving to be appropriate to achieve the planned outputs and contribute to the achievement of the outcomes?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ23Have" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ23Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ23Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ23Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ24Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ24Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.2 Did the partner government and other partners effectively steer the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ25Have" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ25Have, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ25Have, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ25Have, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ26Have"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ26Have}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.3a Were the inputs / resources provided by the various stakeholders adequate for achieving the planned results?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ27Inputs" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ27Inputs, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ27Inputs, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ27Inputs, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        rows={2}
                                        name="EmqQ28Inputs"
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ28Inputs}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.3b Were resources other than EU funds made available for the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ29What" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ29What, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ29What, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ29What, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ30What"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ30What}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.3c To what degree were resources (inputs) from other stakeholders available on time?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ31Towhat" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ31Towhat, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ31Towhat, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ31Towhat, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ32Towhat"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ32Towhat}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.4 Did the project encounter any delays? If yes, how important were they and what were the consequences on the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ33Delays" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ33Delays, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ33Delays, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ33Delays, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ34Delays"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ34Delays}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.5 Were the outputs produced/ delivered in a cost-efficient manner?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ35Were" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ35Were, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ35Were, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ35Were, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ36Were"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ36Were}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >2.6 Was the project adequately monitored by the implementing partner, the partner government and other key stakeholders?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ37Wasthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ37Wasthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ37Wasthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ37Wasthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ38Wasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ38Wasthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 2 (Efficiency)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqConclusion2Efficiency"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqConclusion2Efficiency}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>3. Effectiveness</p>




                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.1 Was the progress of each output conforming to plan?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ39Hasthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ39Hasthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ39Hasthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ39Hasthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ40Hasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ40Hasthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.2 Were the outputs (including those related to Capacity Development) being achieved with the expected quality? </Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ41Hasthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ41Hasthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ41Hasthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ41Hasthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ42Hasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ42Hasthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.3 Were the expected outcomes achieved (including Capacity Development)?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ43Towhat" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ43Towhat, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ43Towhat, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ43Towhat, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ44Towhat"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ44Towhat}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >3.4 Did the P/P effectively influence the partner government’s related policies and actions?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ45Didthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ45Didthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ45Didthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ45Didthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ46Didthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ46Didthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>





                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 3 (Effectiveness)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqConclusion3Effectiveness"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqConclusion3Effectiveness}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>4. Impact</p>





                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.1 Has there been an apparent impact of the action?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ47Hasthere" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ47Hasthere, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ47Hasthere, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ47Hasthere, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ48Hasthere"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ48Hasthere}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.2 To what extent did the project have an indirect positive and/or negative impact?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ49Towhat" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ49Towhat, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ49Towhat, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ49Towhat, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ50Towhat"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ50Towhat}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >4.3 To what extent have there been external factors that positively or negatively affected the impact of the project? Have measures been implemented to minimize these factors?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ51Towhat" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ51Towhat, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ51Towhat, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ51Towhat, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ52Towhat"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ52Towhat}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Conclusion 4 (Impact)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqConclusion4Impact"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqConclusion4Impact}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>5. Sustainability</p>



                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.1 Have key stakeholders attained the necessary capacities (including institutional, human and financial) to ensure the continued flow of benefits/services?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ53Hasthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ53Hasthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ53Hasthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ53Hasthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ54Hasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ54Hasthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.2 Have the key stakeholders provided adequate coordination, interaction and support to the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ55Hasthe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ55Hasthe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ55Hasthe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ55Hasthe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ56Hasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ56Hasthe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.3 Is access to the benefits generated by the project affordable for target groups over the long term?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ57Haveaccess" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ57Haveaccess, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ57Haveaccess, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ57Haveaccess, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ58Haveaccess"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ58Haveaccess}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.4 Has the Beneficiary taken the financial measure(s) to ensure the continuation of services after the end of the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ59Havethe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ59Havethe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ59Havethe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ59Havethe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ60Havethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ60Havethe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.5 Has the private sector been sufficiently involved with a view to contributing to the sustainability of the project?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ61Towhat" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ61Towhat, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ61Towhat, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ61Towhat, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ62Towhat"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ62Towhat}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.6 Have the necessary measures been taken to address environmental sustainability?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ63Havethe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ63Havethe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ63Havethe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ63Havethe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ64Havethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ64Havethe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>
                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >5.7 Have the necessary measures been taken into account to enhance the role of women?</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqQ65Havethe" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ65Havethe, "1")} control={<Radio />} className="green" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ65Havethe, "2")} control={<Radio />} className="orange" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ65Havethe, "3")} control={<Radio />} className="red" />
                                    </Grid>
                                </RadioGroup>

                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ66Havethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ66Havethe}
                                    />

                                </Grid>
                            </ExpansionPanelDetails>


                        </ExpansionPanel>


                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Lessons Learnt</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqLessonsLearnt"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqLessonsLearnt}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>



                        <br />
                        <p>6. Horizontal</p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >6.1 Was the project ROM monitored previously?</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ68Hasthe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ68Hasthe}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >6.2 Have the communication and visibility actions been implemented in an appropriate manner?</Typography>
                            </ExpansionPanelSummary>

                            {
                                //<ExpansionPanelDetails>
                                //    <RadioGroup aria-label="gender" name="EmqQ67Havethe" >
                                //        <Grid item xs direction="column">
                                //            <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ67Havethe, "1")} control={<Radio />} className="green" />
                                //            <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ67Havethe, "2")} control={<Radio />} className="orange" />
                                //            <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ67Havethe, "3")} control={<Radio />} className="red" />
                                //        </Grid>
                                //    </RadioGroup>

                                //</ExpansionPanelDetails>
                            }

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ69Havethe"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ69Havethe}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>


                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >6.3 Are there good practices inherent to the project which could be useful to share beyond the project context?</Typography>
                            </ExpansionPanelSummary>

                            {
                                //<ExpansionPanelDetails>
                                //    <RadioGroup aria-label="gender" name="EmqQ69Werethere" >
                                //        <Grid item xs direction="column">
                                //            <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqQ69Werethere, "1")} control={<Radio />} className="green" />
                                //            <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqQ69Werethere, "2")} control={<Radio />} className="orange" />
                                //            <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqQ69Werethere, "3")} control={<Radio />} className="red" />
                                //        </Grid>
                                //    </RadioGroup>

                                //</ExpansionPanelDetails>
                            }

                            <ExpansionPanelDetails>
                                <Grid item xs direction="column">
                                    <TextareaAutosize
                                        name="EmqQ70Werethere"
                                        rows={2}
                                        style={{ width: "100%" }}
                                        defaultValue={this.state.pageLoadData.EmqQ70Werethere}
                                    />
                                </Grid>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <br />
                        <p><b>Sources of Information: List all documents analysed</b></p>
                        <p>Essential Project/Programme documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Country Programming documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC1Country" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC1Country, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC1Country, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC1Country, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Project/Action Documents</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC2ProjectDocuments" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC2ProjectDocuments, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC2ProjectDocuments, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC2ProjectDocuments, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >QSG checklists</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC3QSG" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC3QSG, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC3QSG, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC3QSG, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Financing/Contribution/Delegation/Administration Agreement or grant contract (or in some cases service contracts).</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                In these documents, all annexes are to be included such as Technical and Administrative provisions, Implementation schedule, logframe (incl. updates)
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC4FinancingContribution" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC4FinancingContribution, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC4FinancingContribution, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC4FinancingContribution, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Project contracts/programme estimates</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC5ProjectContracts" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC5ProjectContracts, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC5ProjectContracts, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC5ProjectContracts, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >In case of projects selected through calls for proposals: Guidelines for calls for proposals</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC6InCaseOf" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC6InCaseOf, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC6InCaseOf, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC6InCaseOf, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Riders to all the documents listed above and their explanatory notes</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC7Riders" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC7Riders, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC7Riders, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC7Riders, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Annual and overall activity schedules/implementation plans</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC8Annual" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC8Annual, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC8Annual, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC8Annual, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Implementation progress reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC9Implementation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC9Implementation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC9Implementation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC9Implementation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Previous ROM Reports</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC10PreviousROM" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC10PreviousROM, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC10PreviousROM, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC10PreviousROM, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Mid-term evaluations</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC11MidtermEvaluation" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC11MidtermEvaluation, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC11MidtermEvaluation, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC11MidtermEvaluation, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Final evaluations of previous phases (if any)</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC12FinalEvaluations" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC12FinalEvaluations, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC12FinalEvaluations, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC12FinalEvaluations, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography >Thematic studies and consultancy reports related to Project</Typography>
                            </ExpansionPanelSummary>
                            <ExpansionPanelDetails>
                                <RadioGroup aria-label="gender" name="EmqC13ThematicStudies" >
                                    <Grid item xs direction="column">
                                        <FormControlLabel value="1" checked={this.checkIfChecked(pageLoadData.EmqC13ThematicStudies, "1")} control={<Radio />} label="Yes" />
                                        <FormControlLabel value="2" checked={this.checkIfChecked(pageLoadData.EmqC13ThematicStudies, "2")} control={<Radio />} label="No" />
                                        <FormControlLabel value="3" checked={this.checkIfChecked(pageLoadData.EmqC13ThematicStudies, "3")} control={<Radio />} label="N/A" />
                                    </Grid>
                                </RadioGroup>
                            </ExpansionPanelDetails>
                        </ExpansionPanel>

                        <br />
                        <p>Other Documents</p>

                        <ExpansionPanel style={{ width: "50%" }}>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>Other Documents</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 0 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD1" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 0 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD1} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 1 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD2" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 1 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD2} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 2 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD3" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 2 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD3} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 3 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD4" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 3 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD4} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 4 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD5" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 4 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD5} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 5 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD6" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 5 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD6} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 6 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD7" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 6 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD7} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 7 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD8" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 7 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD8} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 8 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD9" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 8 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD9} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 9 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD10" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 9 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD10} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 10 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD11" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 10 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD11} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 11 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD12" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 11 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD12} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 12 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD13" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 12 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD13} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 13 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD14" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 13 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD14} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 14 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD15" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 14 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD15} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 15 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD16" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 15 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD16} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 16 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD17" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 16 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD17} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 17 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD18" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 17 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD18} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 18 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD19" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 18 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD19} />
                                </Grid>
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countOtherDocuments > 19 ? "block" : "none" }}>
                                <Grid item xs container direction="column" spacing={2}>
                                    <TextareaAutosize name="EmqOtherDocumentsD20" rows={6}
                                        style={{ width: "100%", display: countOtherDocuments > 19 ? "block" : "none" }}
                                        defaultValue={this.state.pageLoadData.EmqOtherDocumentsD20} />
                                </Grid>
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementOtherDocuments.bind(this)}
                                    >
                                        Add Documents
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>


                        <br />
                        <p><b>Sources of Information: List of persons interviewed</b></p>

                        <ExpansionPanel>
                            <ExpansionPanelSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2a-content"
                                id="panel2a-header"
                            >
                                <Typography>List Of Persons Interviewed</Typography>
                            </ExpansionPanelSummary>

                            <ExpansionPanelDetails style={{ display: countPerson > 0 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP1PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP1PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP1PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP1PersonName"
                                    value={pageLoadData.EmqSOIP1PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP1PersonEmail"
                                    value={pageLoadData.EmqSOIP1PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP1PersonPosition"
                                    value={pageLoadData.EmqSOIP1PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP1PersonInstitution"
                                    value={pageLoadData.EmqSOIP1PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 1 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP2PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP2PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP2PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP2PersonName"
                                    value={pageLoadData.EmqSOIP2PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP2PersonEmail"
                                    value={pageLoadData.EmqSOIP2PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP2PersonPosition"
                                    value={pageLoadData.EmqSOIP2PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP2PersonInstitution"
                                    value={pageLoadData.EmqSOIP2PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 2 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP3PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP3PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP3PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP3PersonName"
                                    value={pageLoadData.EmqSOIP3PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP3PersonEmail"
                                    value={pageLoadData.EmqSOIP3PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP3PersonPosition"
                                    value={pageLoadData.EmqSOIP3PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP3PersonInstitution"
                                    value={pageLoadData.EmqSOIP3PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 3 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP4PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP4PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP4PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP4PersonName"
                                    value={pageLoadData.EmqSOIP4PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP4PersonEmail"
                                    value={pageLoadData.EmqSOIP4PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP4PersonPosition"
                                    value={pageLoadData.EmqSOIP4PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP4PersonInstitution"
                                    value={pageLoadData.EmqSOIP4PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 4 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP5PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP5PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP5PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP5PersonName"
                                    value={pageLoadData.EmqSOIP5PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP5PersonEmail"
                                    value={pageLoadData.EmqSOIP5PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP5PersonPosition"
                                    value={pageLoadData.EmqSOIP5PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP5PersonInstitution"
                                    value={pageLoadData.EmqSOIP5PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 5 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP6PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP6PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP6PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP6PersonName"
                                    value={pageLoadData.EmqSOIP6PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP6PersonEmail"
                                    value={pageLoadData.EmqSOIP6PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP6PersonPosition"
                                    value={pageLoadData.EmqSOIP6PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP6PersonInstitution"
                                    value={pageLoadData.EmqSOIP6PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 6 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP7PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP7PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP7PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP7PersonName"
                                    value={pageLoadData.EmqSOIP7PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP7PersonEmail"
                                    value={pageLoadData.EmqSOIP7PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP7PersonPosition"
                                    value={pageLoadData.EmqSOIP7PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP7PersonInstitution"
                                    value={pageLoadData.EmqSOIP7PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 7 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP8PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP8PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP8PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP8PersonName"
                                    value={pageLoadData.EmqSOIP8PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP8PersonEmail"
                                    value={pageLoadData.EmqSOIP8PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP8PersonPosition"
                                    value={pageLoadData.EmqSOIP8PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP8PersonInstitution"
                                    value={pageLoadData.EmqSOIP8PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 8 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP9PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP9PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP9PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP9PersonName"
                                    value={pageLoadData.EmqSOIP9PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP9PersonEmail"
                                    value={pageLoadData.EmqSOIP9PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP9PersonPosition"
                                    value={pageLoadData.EmqSOIP9PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP9PersonInstitution"
                                    value={pageLoadData.EmqSOIP9PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 9 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP10PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP10PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP10PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP10PersonName"
                                    value={pageLoadData.EmqSOIP10PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP10PersonEmail"
                                    value={pageLoadData.EmqSOIP10PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP10PersonPosition"
                                    value={pageLoadData.EmqSOIP10PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP10PersonInstitution"
                                    value={pageLoadData.EmqSOIP10PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 10 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP11PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP11PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP11PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP11PersonName"
                                    value={pageLoadData.EmqSOIP11PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP11PersonEmail"
                                    value={pageLoadData.EmqSOIP11PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP11PersonPosition"
                                    value={pageLoadData.EmqSOIP11PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP11PersonInstitution"
                                    value={pageLoadData.EmqSOIP11PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 11 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP12PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP12PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP12PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP12PersonName"
                                    value={pageLoadData.EmqSOIP12PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP12PersonEmail"
                                    value={pageLoadData.EmqSOIP12PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP12PersonPosition"
                                    value={pageLoadData.EmqSOIP12PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP12PersonInstitution"
                                    value={pageLoadData.EmqSOIP12PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 12 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP13PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP13PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP13PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP13PersonName"
                                    value={pageLoadData.EmqSOIP13PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP13PersonEmail"
                                    value={pageLoadData.EmqSOIP13PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP13PersonPosition"
                                    value={pageLoadData.EmqSOIP13PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP13PersonInstitution"
                                    value={pageLoadData.EmqSOIP13PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 13 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP14PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP14PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP14PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP14PersonName"
                                    value={pageLoadData.EmqSOIP14PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP14PersonEmail"
                                    value={pageLoadData.EmqSOIP14PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP14PersonPosition"
                                    value={pageLoadData.EmqSOIP14PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP14PersonInstitution"
                                    value={pageLoadData.EmqSOIP14PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 14 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP15PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP15PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP15PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP15PersonName"
                                    value={pageLoadData.EmqSOIP15PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP15PersonEmail"
                                    value={pageLoadData.EmqSOIP15PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP15PersonPosition"
                                    value={pageLoadData.EmqSOIP15PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP15PersonInstitution"
                                    value={pageLoadData.EmqSOIP15PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 15 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP16PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP16PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP16PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP16PersonName"
                                    value={pageLoadData.EmqSOIP16PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP16PersonEmail"
                                    value={pageLoadData.EmqSOIP16PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP16PersonPosition"
                                    value={pageLoadData.EmqSOIP16PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP16PersonInstitution"
                                    value={pageLoadData.EmqSOIP16PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 16 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP17PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP17PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP17PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP17PersonName"
                                    value={pageLoadData.EmqSOIP17PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP17PersonEmail"
                                    value={pageLoadData.EmqSOIP17PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP17PersonPosition"
                                    value={pageLoadData.EmqSOIP17PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP17PersonInstitution"
                                    value={pageLoadData.EmqSOIP17PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 17 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP18PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP18PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP18PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP18PersonName"
                                    value={pageLoadData.EmqSOIP18PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP18PersonEmail"
                                    value={pageLoadData.EmqSOIP18PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP18PersonPosition"
                                    value={pageLoadData.EmqSOIP18PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP18PersonInstitution"
                                    value={pageLoadData.EmqSOIP18PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 18 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP19PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP19PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP19PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP19PersonName"
                                    value={pageLoadData.EmqSOIP19PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP19PersonEmail"
                                    value={pageLoadData.EmqSOIP19PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP19PersonPosition"
                                    value={pageLoadData.EmqSOIP19PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP19PersonInstitution"
                                    value={pageLoadData.EmqSOIP19PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>
                            <ExpansionPanelDetails style={{ display: countPerson > 19 ? "flex" : "none" }}>
                                <Autocomplete
                                    options={interviewPersonCategories}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangePageLoadData(e, v, "EmqSOIP20PersonCategory")}
                                    value={this.returnArrayElementUseValue(interviewPersonCategories, pageLoadData.EmqSOIP20PersonCategory)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            name="EmqSOIP20PersonCategory"
                                            label="Categories :"
                                            placeholder="Categories"
                                            fullWidth
                                            margin="normal"
                                            style={{ width: "200px" }}
                                        />
                                    )}
                                />
                                <TextField
                                    label="Name :"
                                    placeholder="Name"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP20PersonName"
                                    value={pageLoadData.EmqSOIP20PersonName}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Email :"
                                    placeholder="Email"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP20PersonEmail"
                                    value={pageLoadData.EmqSOIP20PersonEmail}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Position :"
                                    placeholder="Position"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP20PersonPosition"
                                    value={pageLoadData.EmqSOIP20PersonPosition}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                                <TextField
                                    label="Institution :"
                                    placeholder="Institution"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true
                                    }}
                                    name="EmqSOIP20PersonInstitution"
                                    value={pageLoadData.EmqSOIP20PersonInstitution}
                                    style={{ marginLeft: "5px", marginRight: "5px" }}
                                />
                            </ExpansionPanelDetails>

                            <ExpansionPanelDetails>
                                <Grid item xs>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={this.incrementPerson.bind(this)}
                                    >
                                        Add Person
                                </Button>
                                </Grid>
                            </ExpansionPanelDetails>

                        </ExpansionPanel>



                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }} className="mt-1">
                        <Button variant="contained" color="primary" type="submit">
                            SAVE
					</Button>
                    </Grid>
                </AutoForm>
            </Grid>
        );
    }
}





// WEBPACK FOOTER //
// ./src/pages/E_Mq.js